import React from 'react'
import baseRouter from '@/utils/baseRouter'
import { buildServerSideContext, buildServerSideProps } from '@/utils/buildServerSide'
import CartView from '@/views/Cart'

const router = baseRouter().get(async (_req, res) => {
    const excludedScripts = []

    const pageData = {
        title: 'Cart | Smarter Luxury Sleep',
        pageType: 'cart',
        excludedScripts: excludedScripts,
    }
    return {
        props: buildServerSideProps(pageData, res.locals)
    }
})

export function getServerSideProps(context) {
    const { req, res } = buildServerSideContext(context)
    return router.run(req, res)
}

export default function MainPage(props) {
    return <CartView {...props} />
}
